import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

const PricingField = ({ contentData, setContentData, showIcons, setShowIcons }: any) => {
    const [formValues, setFormValues] = useState({
        price: contentData.price || '', // Initialize with existing price in contentData
    });

    const formatCurrency = (value: string) => {
        // Remove any non-numeric characters except for the decimal point
        const numericValue = value.replace(/[^\d.]/g, '');
        return numericValue ? `$${numericValue}` : '';
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let { name, value } = e.target;

        // Format the input value as currency
        value = formatCurrency(value);

        // Set the form value with the formatted currency
        setFormValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));

        // Update the parent component's contentData with the numeric price (removing the $ sign)
        setContentData((prevContentData: any) => ({
            ...prevContentData,
            price: value.replace('$', ''), // Save only the numeric value
        }));

        // Update showIcons visibility based on whether there is input in the price field
        setShowIcons((prevState: any) => ({
            ...prevState,
            pricing: value.length > 0, // Show or hide icon based on input length
        }));
    };

    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} gap={1} display={"flex"} flexDirection={"column"}>
                <label
                    htmlFor="price"
                    style={styleSheet.labelText}
                >
                    Price
                </label>
                <Grid display={"flex"} alignItems={"center"} flex={1}>
                    <Box sx={{ flexGrow: 1, display: "flex", gap: 1, alignItems: "center" }}>
                        <CustomTextField
                            name="price"
                            type="text" // Changed to text to handle currency symbol
                            placeholder='$'
                            sx={{ width: '100%', maxWidth: '654px' }}
                            value={formValues.price}
                            onChange={handleChange}
                        />
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default PricingField;

const styleSheet = {
    labelText: {
        fontWeight: 400, fontSize: "17px", color: "#000000",
    }
};
